/** The app's name and icon as people see them. (The code and repository are still called webthing.) */
export const APP_NAME = "Home AI";

/** The icon's shapes in a 32x32 viewBox, the same as public/favicon.svg (scripts/make_icons.py draws both). */
export const ICON_SVG_BODY =
  '<rect width="32" height="32" rx="8" fill="#4f46e5"/><rect x="5" y="6.5" width="22" height="16.5" rx="5" fill="#fff"/><path d="M9 22L8 27.5L15 22.5Z" fill="#fff"/><path d="M16 9.2L22.2 14.6H9.8Z" fill="#4f46e5"/><rect x="11.8" y="14.2" width="8.4" height="5.8" fill="#4f46e5"/><rect x="14.8" y="16.4" width="2.4" height="3.6" rx="0.6" fill="#fff"/>';
